/*
 * Cart drawer — qty=1 minus deletes the line item.
 *
 * Stock Dawn behavior at qty=1: the input has min="1", so clicking the
 * minus button does nothing (browser clamps the decrement). We override
 * that to mean "remove the item" — same end-state as decrementing to 0,
 * but more direct and matches the brand pattern carried over from the
 * Rebuy cart (where the trash icon was hidden in the standard layout
 * and minus-at-1 was the deletion path).
 *
 * Routed through the existing <cart-remove-button> element, whose click
 * handler in cart.js calls cartItems.updateQuantity(index, 0). The
 * remove button is visually hidden via CSS but kept in DOM specifically
 * as the JS hook for this flow.
 *
 * Scoped to #CartDrawer so the standalone /cart page (where the trash
 * is visible and qty inputs behave the standard way) is unaffected.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quantity__button[name="minus"]');
    if (!btn) return;
    if (!btn.closest('#CartDrawer')) return;

    var item = btn.closest('.cart-item');
    if (!item) return;

    var input = item.querySelector('.quantity__input');
    if (!input) return;

    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty !== 1) return;

    var removeBtn = item.querySelector('cart-remove-button');
    if (!removeBtn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    /* Defer to next tick to avoid colliding with Dawn's quantity-input
       internal handlers — they run on the same click and can race. */
    setTimeout(function () {
      removeBtn.click();
    }, 0);
  }, true);
})();
